import { cartProductAvailable } from '../../../../../Utils/cartAvailability';
import DeliveryClosedNotice from '../../../../../components/DeliveryClosedNotice';
import { useStoreWelcomeModal } from '../../../../../hooks/useStoreWelcomeModal';
import { useDeliveryStatus } from '../../../../../hooks/useDeliveryStatus';
import { getDeliveryClosedReason } from '../../../../../Utils/storeStatus';
import {
  IonButton,
  IonAlert,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonLabel,
  IonLoading,
  IonModal,
  IonPage,
  IonRow,
  IonToast,
  IonToolbar,
  useIonViewDidEnter
} from '@ionic/react';
import '@ionic/react/css/ionic-swiper.css';
import { alertCircleOutline, arrowBackOutline, cartOutline, giftOutline, logoWhatsapp, syncOutline, ticketOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { useCartProductRequest } from '../../../../../hooks/useCartProductRequest';
import useAnalytics from '../../../../../hooks/useAnalytics';
import { empresaCarregar, requestService } from '../../../../../Utils/Services';
import { applyEmpresaTheme, resetEmpresaTheme } from '../../../../../Utils/empresaTheme';
import { clearDiscoveryStoreSelection, isStoreSelectedFromDiscovery, markStoreSelectedFromDiscovery } from '../../../../../Utils/storeSelectionStorage';
import Carrinho from '../../../../Inicio/Carrinho/Carrinho';
import InformacoesEmpresa from '../../../../Inicio/InformacoesEmpresa/InformacoesEmpresa';
import OrdensProdutosCompor from '../../../../Inicio/OrdensProdutosCompor/OrdensProdutosCompor';
import './Inicio.css';
import LojaDiscovery from './LojaDiscovery';

const Inicio: React.FC = () => {

  // Hooks de navegação
  const history = useHistory<any>();
  // const [empresaid, setEmpresaid] = useState<any>();

  const { notificacoes, setNotificacoes } = useContext(MessageContext);
  const [showNotificacoes, setShowNotificacoes] = useState(false);
  const analytics = useAnalytics();

  const [showModalCarrinho, setShowModalCarrinho] = useState(!true);


  // Estados relacionados a loading e feedback visual
  const [showLoading, setShowLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  // Estados de dados e listas
  const { listaItemProdutos, setListaItemProdutos } = useContext(MessageContext);
  const [valorTotalProdutos, setValorTotalProdutos] = useState<any>();

  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);
  const { productRequest, chooseProduct } = useCartProductRequest(dadosEmpresa, setDadosEmpresa);
  const currentCartItems = useRef(listaItemProdutos);
  currentCartItems.current = listaItemProdutos;
  useDeliveryStatus();

  // Referências
  const contentCatalogoRef = useRef<any>(null);
  const contentRef = useRef<HTMLIonContentElement | null>(null);

  const [showModalInformacoes, setShowModalInformacoes] = useState(false);
  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

  // no topo do componente
  const [showHorarioInfo, setShowHorarioInfo] = useState(true);

  // ===== ESTADOS =====
  const [selectedCategoria, setSelectedCategoria] = useState<string>('');
  const [isManualScrolling, setIsManualScrolling] = useState(false);

  // ===== REF =====
  const categoriasRef = useRef<HTMLDivElement>(null);

  const headerRef = useRef<HTMLDivElement>(null);

  const { welcomeModal, dismissWelcomeModal } = useStoreWelcomeModal(dadosEmpresa, new URLSearchParams(window.location.search).get('abrirCarrinho') === 'true');
  const [checkingSavedStore, setCheckingSavedStore] = useState(
    !dadosEmpresa && Boolean(window.localStorage.getItem('empresaid'))
  );
  const [showConfirmStoreSwitch, setShowConfirmStoreSwitch] = useState(false);
  const [storeSelectedFromDiscovery, setStoreSelectedFromDiscovery] = useState(
    () => isStoreSelectedFromDiscovery()
  );
  const savedStoreLoadAttempted = useRef(false);




  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('abrirCarrinho') === 'true') {
      setShowModalCarrinho(true);
    }
  }, []);

  useEffect(() => {
    const rect = headerRef.current?.getBoundingClientRect();
    console.log("bottom:", rect?.bottom);
  }, []);


  useEffect(() => {
    if (!selectedCategoria || !categoriasRef.current) return;

    const btn = categoriasRef.current.querySelector(
      `[data-categoria="${selectedCategoria}"]`
    ) as HTMLElement | null;

    if (btn && categoriasRef.current) {
      const container = categoriasRef.current;
      const btnRect = btn.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      const offset = btnRect.left - containerRect.left + container.scrollLeft;

      container.scrollTo({
        left: offset - container.clientWidth / 2 + btnRect.width / 2,
        behavior: "smooth",
      });
    }
  }, [selectedCategoria]);

  const scrollToCategory = async (categoryName: string) => {
    setIsManualScrolling(true);
    setSelectedCategoria(categoryName);

    const el = document.getElementById(`category-${categoryName}`);
    if (!el) {
      setTimeout(() => setIsManualScrolling(false), 300);
      return;
    }

    try {
      // tenta pegar o elemento real que faz o scroll dentro do IonContent
      const scrollEl: HTMLElement | null = contentRef.current ? await contentRef.current.getScrollElement() : null;

      // altura da base do header na viewport
      const headerEl = document.querySelector('#div-header-content') as HTMLElement | null;
      console.log("headerEl.getBoundingClientRect().bottom", headerEl?.getBoundingClientRect().bottom);
      const headerBottom = headerEl ? headerEl.getBoundingClientRect().bottom : 0;
      const EXTRA_TOP = 6; // ajuste fino se precisar

      if (scrollEl) {
        // rects relativos à viewport
        const scrollRect = scrollEl.getBoundingClientRect();
        const elRect = el.getBoundingClientRect();

        // queremos que o topo do elemento fique logo abaixo do header:
        const desiredTopInViewport = headerBottom + EXTRA_TOP;
        // diferença em px entre a posição atual do elemento e a posição desejada (na viewport)
        const deltaViewport = elRect.top - desiredTopInViewport;

        // converte para target absoluto em scrollTop do scrollEl
        const target = Math.max(0, scrollEl.scrollTop + deltaViewport);

        console.log('[SCROLL] category:', categoryName, {
          elOffsetTop: el.offsetTop,
          elRectTop: elRect.top,
          headerBottom,
          deltaViewport,
          scrollTop: scrollEl.scrollTop,
          target
        });

        // faz o scroll no container interno (mais confiável)
        scrollEl.scrollTo({ top: target, behavior: 'smooth' });
      } else {
        // fallback: usa scrollIntoView + ajusta scroll-margin-top para compensar o header
        el.style.scrollMarginTop = `${headerBottom + EXTRA_TOP}px`;
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } catch (err) {
      console.warn('scrollToCategory error', err);
    } finally {
      // libera o spy depois do scroll (pequeno delay)
      setTimeout(() => setIsManualScrolling(false), 400);
    }
  };

  // ===== SCROLL SPY =====
  const handleContentScroll = (e: any) => {
    if (isManualScrolling) return;

    const scrollTop = e?.detail?.scrollTop ?? 0;

    // Controla a visibilidade do conteúdo de horário baseado no scroll
    const threshold = 100; // pixels de scroll para esconder o conteúdo
    setShowHorarioInfo(scrollTop < threshold);

    const allCategories =
      dadosEmpresa?.categoriaProdutos?.filter((c: any) => {
        // Filtro 1: Não mostrar complementos
        if (c.tipo === "complementos") return false;

        // Filtro 2: Verificar se a categoria tem produtos disponíveis
        return shouldShowCategory(c);
      }) || [];

    const headerEl = document.querySelector('#div-header-content') as HTMLElement | null;
    console.log("headerEl.getBoundingClientRect().bottom", headerEl?.getBoundingClientRect().bottom);
    const headerBottom = headerEl ? headerEl.getBoundingClientRect().bottom : 130;

    // Se ainda não temos categoria selecionada, seleciona a primeira visível
    if (!selectedCategoria && allCategories.length > 0) {
      const firstCategory = allCategories[0];
      const firstEl = document.getElementById(`category-${firstCategory.nome}`);
      if (firstEl) {
        const firstRect = firstEl.getBoundingClientRect();
        if (firstRect.bottom > headerBottom) {
          setSelectedCategoria(firstCategory.nome);
          return;
        }
      }
    }

    if (selectedCategoria) {
      const currentIndex = allCategories.findIndex((cat: any) => cat.nome === selectedCategoria);

      // Verifica se alguma categoria anterior está começando a aparecer (scroll para cima)
      for (let i = currentIndex - 1; i >= 0; i--) {
        const prevCat = allCategories[i];
        const prevEl = document.getElementById(`category-${prevCat.nome}`);
        if (prevEl) {
          const prevRect = prevEl.getBoundingClientRect();
          // Se a categoria anterior está aparecendo na tela
          if (prevRect.bottom > headerBottom && prevRect.top < window.innerHeight) {
            setSelectedCategoria(prevCat.nome);
            return;
          }
        }
      }

      // Verifica se a categoria atual ainda está visível
      const currentEl = document.getElementById(`category-${selectedCategoria}`);
      if (currentEl) {
        const currentRect = currentEl.getBoundingClientRect();

        // Se a categoria atual ainda está visível na tela, mantém
        if (currentRect.bottom > headerBottom && currentRect.top < window.innerHeight) {
          return; // Mantém a categoria atual
        }

        // Se a categoria atual saiu completamente por cima (scroll para baixo)
        if (currentRect.bottom <= headerBottom) {
          // Procura a próxima categoria que está visível
          for (let i = currentIndex + 1; i < allCategories.length; i++) {
            const nextCat = allCategories[i];
            const nextEl = document.getElementById(`category-${nextCat.nome}`);
            if (nextEl) {
              const nextRect = nextEl.getBoundingClientRect();
              // Se a próxima categoria está visível, seleciona ela
              if (nextRect.bottom > headerBottom && nextRect.top < window.innerHeight) {
                setSelectedCategoria(nextCat.nome);
                return;
              }
            }
          }
        }
      }
    }
  };

  const getHeaderOffset = () => {
    // pega o #div-header-content (inclui ambos toolbars) e usa a altura real
    const headerEl = document.querySelector('#div-header-content') as HTMLElement | null;
    console.log("headerEl.getBoundingClientRect().bottom", headerEl?.getBoundingClientRect().bottom);
    return headerEl ? headerEl.getBoundingClientRect().bottom : 0;
  };

  // Funções de rolagem
  const scrollToTop = () => {
    if (contentRef.current) {
      contentRef.current.scrollToTop();
    }
  };

  const scrollToCatalogo = () => {
    if (contentCatalogoRef.current) {
      contentCatalogoRef.current.scrollIntoView();
    }
  };

  useIonViewDidEnter(() => {

    setEsconderMenu(false);
    scrollToTop();

    // // Fallback: se dadosEmpresa não está no contexto (ex: reload após login), carrega via localStorage
    // if (!dadosEmpresa) {
    //   const empresaid = localStorage.getItem("empresaid") || "";
    //   if (empresaid) {
    //     carregarEmpresa(empresaid);
    //   }
    // }
  });

  useEffect(() => {
    if (dadosEmpresa) {
      setStoreSelectedFromDiscovery(isStoreSelectedFromDiscovery(dadosEmpresa.pk));
      setCheckingSavedStore(false);
      return;
    }

    const savedStoreId = window.localStorage.getItem('empresaid');
    if (!savedStoreId || savedStoreLoadAttempted.current) {
      setCheckingSavedStore(false);
      return;
    }

    savedStoreLoadAttempted.current = true;
    setCheckingSavedStore(true);
    carregarEmpresa(savedStoreId).finally(() => setCheckingSavedStore(false));
    // A tentativa é controlada pela ref para não duplicar o carregamento feito no App.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dadosEmpresa]);

  useEffect(() => {
    console.log("entrou useEffect");
    carregarSomasItemProdutos();
  }, [listaItemProdutos]);

  function carregarSomasItemProdutos() {

    // Calcula a nova soma dos valores após a remoção
    const totalValor = listaItemProdutos.reduce((total: any, item: any) => {
      const itemValorNumerico = parseFloat(
        item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
      );
      return total + itemValorNumerico;
    }, 0);

    // Exemplo: você pode armazenar a nova soma em outro estado ou usar conforme necessário
    console.log("Nova soma dos valores:", totalValor);

    setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }));

  }

  async function carregarEmpresa(loja: any, selectedFromDiscovery = false): Promise<boolean> {
    if (!loja) return false;

    setShowLoading(true);
    const empresaidFormatado = loja.startsWith('empresa#') ? loja : `empresa#${loja}`;

    return new Promise((resolve) => {
      requestService(empresaCarregar.url.replace("{id}", empresaidFormatado.replace(/#/g, '%23')), {
        method: empresaCarregar.method
      },
        history,
        (response: any) => {
          const item = response?.Item;
          if (!item) {
            setShowLoading(false);
            resolve(false);
            return;
          }

          setDadosEmpresa(item);
          if (selectedFromDiscovery) {
            markStoreSelectedFromDiscovery(item.pk);
          }
          setStoreSelectedFromDiscovery(isStoreSelectedFromDiscovery(item.pk));
          localStorage.setItem("empresaid", item.pk);
          localStorage.setItem("empresanome", item.empresaNome);
          localStorage.removeItem('slug');
          document.title = item.empresaNome || 'Pedido';
          applyEmpresaTheme(item);

          if (item.estrangeiro) {
            localStorage.setItem("estrangeiro", "true");
          } else {
            localStorage.removeItem("estrangeiro");
          }

          setShowLoading(false);
          resolve(true);
        },
        (error: any) => {
          console.error('Não foi possível carregar a empresa selecionada:', error);
          if (window.localStorage.getItem('empresaid') === empresaidFormatado) {
            window.localStorage.removeItem('empresaid');
            window.localStorage.removeItem('empresanome');
            clearDiscoveryStoreSelection();
          }
          setDadosEmpresa(false);
          setShowLoading(false);
          resolve(false);
        },
        false
      );
    });
  }

  const clearActiveStore = () => {
    // O endereço pertence ao cliente e continua válido ao trocar de loja.
    // Taxa, tempo e agendamento dependem da loja/pedido e precisam ser recalculados.
    const storeKeys = [
      'empresaid',
      'empresanome',
      'slug',
      'estrangeiro',
      'taxaEntrega',
      'tempoEntrega',
      'tipoAgendamento',
      'dataAgendamento',
      'horaAgendamento'
    ];

    storeKeys.forEach((key) => window.localStorage.removeItem(key));
    clearDiscoveryStoreSelection();
    setListaItemProdutos([]);
    setDadosEmpresa(false);
    dismissWelcomeModal();
    setShowConfirmStoreSwitch(false);
    setStoreSelectedFromDiscovery(false);
    savedStoreLoadAttempted.current = true;
    document.title = 'Xeguei';
    resetEmpresaTheme();
  };

  const requestStoreSwitch = (event?: React.MouseEvent) => {
    event?.stopPropagation();
    if (listaItemProdutos?.length > 0) {
      setShowConfirmStoreSwitch(true);
    } else {
      clearActiveStore();
    }
  };

  async function adicionarItem(produto: any, avancarCarrinho: boolean = false) {

    if (!produto) return false;

    if (produto) {

      const updatedList = [...(currentCartItems.current || []), produto];
      currentCartItems.current = updatedList;

      setListaItemProdutos(updatedList);


      let totalValor = updatedList.reduce((total: any, item: any) => {
        const itemValorNumerico = parseFloat(
          item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
        );
        return total + itemValorNumerico;
      }, 0);

      setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }));

      // Analytics: AddToCart
      try { analytics.trackAddToCart(produto, totalValor); } catch (e) { /* noop */ }

      setTextToast("Item adicionado com sucesso.");
      setShowToast(true);

    }

    if (avancarCarrinho) {
      setShowModalCarrinho(true);
    }

    return true;
  }

  async function closeModalInformacoes() {
    setShowModalInformacoes(false);
  }

  async function closeModalCarrinho() {
    setShowModalCarrinho(false);
    history.push("/cliente/ordens");
  }

  async function closeModalCarrinhoVoltar() {
    setShowModalCarrinho(false);
  }

  const calcularHorarioFinal = (start: any, duration: any) => {
    const [hours, minutes] = start.split(':').map(Number);
    const endMinutes = minutes + duration;
    const endHours = hours + Math.floor(endMinutes / 60);
    const finalMinutes = endMinutes % 60;
    return `${endHours.toString().padStart(2, '0')}:${finalMinutes.toString().padStart(2, '0')}`;
  };

  const formatarHorario = (horario: string) => {
    return horario.split(":").slice(0, 2).join(":");
  };

  // certifique-se que contentRef existe:
  // const contentRef = useRef<HTMLIonContentElement | null>(null);

  // ✅ Função para verificar se uma categoria deve ser exibida
  const shouldShowCategory = (categoria: any) => {
    if (!dadosEmpresa?.catalogoProdutos) return false;

    // Encontrar produtos desta categoria
    const produtosDaCategoria = dadosEmpresa.catalogoProdutos.filter((produto: any) =>
      produto.categoria === categoria.nome
    );

    // Verificar se tem pelo menos um produto disponível
    const produtosDisponiveis = produtosDaCategoria.filter((produto: any) => cartProductAvailable(produto));

    return produtosDisponiveis.length > 0;
  };

  // ===== COMPONENTE DE NAVEGAÇÃO DE CATEGORIAS =====
  const renderCategoriaButtons = () => {
    if (dadosEmpresa && dadosEmpresa.categoriaProdutos) {

      return (
        <div className="pedido-categorias-shell" style={{ width: '100%', display: 'flex', padding: '0px 10px', flexDirection: 'column', backgroundColor: 'white', color: 'var(--pedido-text-secondary)' }}>
          {/* Categories row */}
          <div className="pedido-categorias-scroll" ref={categoriasRef} style={{ display: 'flex', flexWrap: 'nowrap', overflowX: 'auto', width: '100%' }}>
            {dadosEmpresa.categoriaProdutos.filter((value: any) => {
              // Filtro 1: Não mostrar complementos
              if (value.tipo === "complementos") return false;

              // Filtro 2: Verificar se a categoria tem produtos disponíveis
              return shouldShowCategory(value);
            }).map((item: any, index: any) => (
              <IonCol size="auto" key={index} style={{
                flex: '0 0 auto',
                textAlign: 'center',
                padding: '12px 16px',
                minHeight: '48px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
                data-categoria={item.nome} // 👈 importante para localizar depois
                onClick={() => { scrollToCategory(item.nome) }}>

                <IonLabel style={{
                  fontSize: '14px',
                  color: selectedCategoria == item.nome ? 'var(--ion-color-primary)' : 'var(--pedido-text-secondary)',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  padding: '8px 12px',
                  borderRadius: '6px',
                  // backgroundColor: selectedCategoria == item.nome ? '#fff5f5' : 'transparent',
                  // transition: 'all 0.2s ease'
                }}>
                  {item.nomeCategoria || item.nome}
                </IonLabel>
              </IonCol>
            ))}
          </div>

        </div>
      );
    }
  };

  function formataTelefone(numero: any) {
    if (numero?.length == 13) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else if (numero?.length == 12) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{4})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else { return "" };
  }

  // ===== COMPONENTE DE INFORMAÇÕES DA EMPRESA =====
  const renderEmpresaInfo = () => {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '20px 16px',
          backgroundColor: '#fff',
          cursor: 'pointer'
        }}
        onClick={() => setShowModalInformacoes(true)}
      >
        {storeSelectedFromDiscovery && (
          <button
            type="button"
            className="inicio-switch-store"
            aria-label="Voltar para a lista de lojas"
            title="Trocar loja"
            onClick={requestStoreSwitch}
          >
            <IonIcon icon={arrowBackOutline} />
          </button>
        )}

        {/* Logo da empresa */}
        {dadosEmpresa?.urlLogo && (
          <img
            src={dadosEmpresa.urlLogo}
            alt="Logo da empresa"
            style={{
              width: '60px',
              height: '60px',
              objectFit: 'cover',
              marginRight: '12px',
              borderRadius: '4px'
            }}
          />
        )}

        <div style={{ flex: 1 }}>
          <div style={{
            fontSize: '16px',
            fontWeight: 'bold',
            color: 'var(--pedido-text-primary)',
            marginBottom: '2px',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            lineHeight: '1'
          }}>
            {dadosEmpresa?.empresaNome}
          </div>

          {dadosEmpresa?.empresaTelefone && (
            <div style={{
              fontSize: '14px',
              color: 'var(--pedido-text-primary)',
              fontWeight: 'normal',
              marginTop: '0px',
              lineHeight: '1',
              marginBottom: '0px'
            }}>
              {formataTelefone(dadosEmpresa.empresaTelefone)}
            </div>
          )}
        </div>

        {/* Ícone de seta para indicar que é clicável */}
        <div style={{
          color: 'var(--pedido-text-secondary)',
          fontSize: '16px',
          fontWeight: 'bold'
        }}>
          ›
        </div>
      </div>
    );
  };

  // ===== COMPONENTE DE INFORMAÇÕES INFERIORES (HORÁRIO, CUPOM, MÍNIMO) =====
  const renderBottomInfo = () => {
    // Lógica do horário (reutilizando do renderHorarioInfo)
    const diasSemanaNumber: any = {
      SUNDAY: 0,
      MONDAY: 1,
      TUESDAY: 2,
      WEDNESDAY: 3,
      THURSDAY: 4,
      FRIDAY: 5,
      SATURDAY: 6,
    };

    const diaAtual = new Date().getDay();
    const diaAtualTexto = Object.keys(diasSemanaNumber).find(
      (key) => diasSemanaNumber[key] === diaAtual
    );

    const diaAmanha = (diaAtual + 1) % 7;
    const amanhaTexto = Object.keys(diasSemanaNumber).find(
      (key) => diasSemanaNumber[key] === diaAmanha
    );

    const horariosHoje = dadosEmpresa?.horarios?.filter(
      (horario: any) => horario.dayOfWeek === diaAtualTexto
    ) || [];

    const horariosAmanha = dadosEmpresa?.horarios?.filter(
      (horario: any) => horario.dayOfWeek === amanhaTexto
    ) || [];

    const agora = new Date();
    const ordenarHorarios = (a: any, b: any) => a.start.localeCompare(b.start);
    const horariosHojeOrdenados = [...horariosHoje].sort(ordenarHorarios);

    let proximoHorarioHoje: any = null;
    let estaAberto = false;

    for (const horario of horariosHojeOrdenados) {
      const [horaInicio, minutoInicio] = horario.start.split(":").map(Number);
      const inicio = new Date();
      inicio.setHours(horaInicio, minutoInicio, 0, 0);
      const fim = new Date(inicio.getTime() + horario.duration * 60000);

      if (agora >= inicio && agora <= fim) {
        estaAberto = true;
        proximoHorarioHoje = horario;
        break;
      }

      if (agora < inicio && !proximoHorarioHoje) {
        proximoHorarioHoje = horario;
      }
    }

    // Determinar texto do horário
    let textoHorario = "";
    let corHorario = "var(--pedido-text-primary)";

    if (dadosEmpresa?.deliveryFechado === true) {
      textoHorario = "Temporariamente fechada";
      corHorario = "#dc3545";
    } else if (estaAberto && proximoHorarioHoje) {
      textoHorario = `Aberto até ${calcularHorarioFinal(proximoHorarioHoje.start, proximoHorarioHoje.duration)}`;
      corHorario = "#28a745";
    } else if (proximoHorarioHoje) {
      textoHorario = `Abre ${formatarHorario(proximoHorarioHoje.start)}`;
      corHorario = "#dc3545";
    } else if (horariosAmanha.length > 0) {
      const proximoHorarioAmanha = [...horariosAmanha].sort(ordenarHorarios)[0];
      textoHorario = `Abre amanhã ${formatarHorario(proximoHorarioAmanha.start)}`;
      corHorario = "#dc3545";
    } else {
      textoHorario = `Fechado`;
      corHorario = "#dc3545";
    }

    // Lógica da taxa de entrega
    const parseTaxa = (v: any): number =>
      // Ordem importa: remove ponto de milhar primeiro, depois troca vírgula por ponto
      parseFloat((v ?? '0').toString().replace(/\./g, '').replace(/,/g, '.')) || 0;

    const formatar = (v: number) =>
      v.toFixed(2).replace('.', ',');

    const tipoEntrega = (dadosEmpresa?.tipoConfiguracoesEntrega || '').toLowerCase();

    const configuracoesEntregaRaw: any[] = Array.isArray(dadosEmpresa?.configuracoesEntrega)
      ? dadosEmpresa.configuracoesEntrega
      : Object.values(dadosEmpresa?.configuracoesEntrega || {});

    const configuracoesEntrega = configuracoesEntregaRaw.filter(
      (t) => t.tipo === tipoEntrega
    );

    let textoTaxaEntrega = 'Sem delivery';

    if (configuracoesEntrega.length === 0) {
      textoTaxaEntrega = 'Sem delivery';

    } else if (tipoEntrega === 'raio') {
      const valores = configuracoesEntrega.map((t) => parseTaxa(t.taxa));
      const menor = Math.min(...valores);
      const maior = Math.max(...valores);

      if (maior === 0) {
        textoTaxaEntrega = 'Grátis';

      } else if (menor === 0 && maior > 0) {
        // ✅ Fix: reduce apenas sobre os itens grátis, sem valor inicial externo ao filtro
        const itensGratis = configuracoesEntrega.filter((t) => parseTaxa(t.taxa) === 0);
        const maiorRaioGratis = itensGratis.reduce((max, t) =>
          Number(t.raio) > Number(max.raio) ? t : max
        );

        textoTaxaEntrega = `Grátis até ${maiorRaioGratis.raio} km`;

      } else {
        const menorItem = configuracoesEntrega.reduce((m, t) =>
          parseTaxa(t.taxa) < parseTaxa(m.taxa) ? t : m
        );

        textoTaxaEntrega = `A partir de R$ ${formatar(parseTaxa(menorItem.taxa))}`;
      }

    } else if (tipoEntrega === 'bairro') {
      const valores = configuracoesEntrega.map((t) => parseTaxa(t.taxa));
      const menor = Math.min(...valores);
      const maior = Math.max(...valores);

      if (maior === 0) {
        textoTaxaEntrega = 'Grátis';

      } else if (menor === 0 && maior > 0) {
        const qtdGratis = configuracoesEntrega.filter(
          (t) => parseTaxa(t.taxa) === 0
        ).length;

        textoTaxaEntrega = `Grátis em ${qtdGratis} ${qtdGratis === 1 ? 'bairro' : 'bairros'}`;

      } else {
        const menorItem = configuracoesEntrega.reduce((m, t) =>
          parseTaxa(t.taxa) < parseTaxa(m.taxa) ? t : m
        );

        textoTaxaEntrega = `A partir de R$ ${formatar(parseTaxa(menorItem.taxa))}`;
      }

    } else if (configuracoesEntrega.length > 0) {
      // ✅ Tipo desconhecido mas com configurações — evita silêncio em produção
      console.warn('[taxaEntrega] Tipo de entrega não reconhecido:', tipoEntrega);
      textoTaxaEntrega = 'Sem delivery';
    }

    return (
      <>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '4px 10px',
          backgroundColor: '#fff',
          // borderTop: '1px solid var(--pedido-gray-border)'
        }}>
          {/* Coluna 1: Horário */}
          <div style={{ flex: 1, textAlign: 'left', padding: '4px 10px' }}>
            <div style={{ fontSize: '12px', color: 'var(--pedido-text-secondary)', marginBottom: '4px' }}>
              Horário
            </div>
            <div style={{ fontSize: '12px', fontWeight: 'bold', color: corHorario }}>
              {textoHorario}
            </div>
          </div>

          {/* Coluna 2: Taxa de Entrega */}
          <div style={{ flex: 1, textAlign: 'left', padding: '4px 10px' }}>
            <div style={{ fontSize: '12px', color: 'var(--pedido-text-secondary)', marginBottom: '4px' }}>
              Taxa de entrega
            </div>
            <div style={{ fontSize: '12px', fontWeight: 'bold', color: 'var(--pedido-text-primary)' }}>
              {textoTaxaEntrega}
            </div>
          </div>

          {/* Coluna 3: Pedido Mínimo */}
          <div style={{ flex: 1, textAlign: 'left', padding: '4px 10px' }}>
            <div style={{ fontSize: '12px', color: 'var(--pedido-text-secondary)', marginBottom: '4px' }}>
              Pedido mínimo
            </div>
            <div style={{ fontSize: '12px', fontWeight: 'bold', color: 'var(--pedido-text-primary)' }}>
              R$ {dadosEmpresa?.pedidoMinimo ? parseFloat(dadosEmpresa.pedidoMinimo.toString()).toLocaleString('pt-br', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }) : '0,00'}
            </div>
          </div>
        </div>

        {/* Seção de Cupons e Cashback - Linha Única Horizontal */}
        {/* {(dadosEmpresa?.configuracoesCupom?.length > 0 || dadosEmpresa?.cashbackAtivado) && (
          <div style={{
            padding: '4px 12px',
            backgroundColor: '#fff',
            borderTop: '0px solid var(--pedido-gray-border)'
          }}>
            <div style={{
              display: 'flex',
              gap: '8px',
              overflowX: 'auto',
              paddingBottom: '2px'
            }}>
              {dadosEmpresa?.cashbackAtivado && (
                <div
                  style={{
                    flex: '0 0 auto',
                    minWidth: '120px',
                    padding: '8px 10px',
                    backgroundColor: '#fff',
                    border: '1px solid var(--pedido-gray-border)',
                    borderRadius: '6px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  <div style={{
                    width: '24px',
                    height: '24px',
                    backgroundColor: '#00a650',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <IonIcon
                      icon={cashOutline}
                      style={{
                        fontSize: '12px',
                        color: '#fff'
                      }}
                    />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{
                      fontSize: '9px',
                      color: 'var(--pedido-text-muted)',
                      marginBottom: '1px'
                    }}>
                      Cashback
                    </div>
                    <div style={{
                      fontSize: '12px',
                      fontWeight: '600',
                      color: 'var(--pedido-text-primary)',
                      marginBottom: '0px'
                    }}>
                      {dadosEmpresa.percentualCashback || 0}%
                    </div>
                    <div style={{
                      fontSize: '9px',
                      color: 'var(--pedido-text-muted)'
                    }}>
                      de volta
                    </div>
                  </div>
                </div>
              )}

              {dadosEmpresa?.configuracoesCupom?.filter((cupom: any) => cupom?.visivel !== false).map((cupom: any, index: number) => {
                const valorStr = (cupom.valor ?? '0').toString();
                const valorNum = parseFloat(valorStr.replace(/\./g, '').replace(/\,/g, '.')) || 0;
                const valorMinimoStr = (cupom.valorMinimo ?? '0').toString();
                const valorMinimoNum = parseFloat(valorMinimoStr.replace(/\./g, '').replace(/\,/g, '.')) || 0;

                return (
                  <div
                    key={`cupom-${index}`}
                    style={{
                      flex: '0 0 auto',
                      minWidth: '120px',
                      padding: '8px 10px',
                      backgroundColor: '#fff',
                      border: '1px solid var(--pedido-gray-border)',
                      borderRadius: '6px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                  >
                    <div style={{
                      width: '24px',
                      height: '24px',
                      backgroundColor: '#00a650',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <IonIcon
                        icon={ticketOutline}
                        style={{
                          fontSize: '12px',
                          color: '#fff'
                        }}
                      />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{
                        fontSize: '9px',
                        color: 'var(--pedido-text-muted)',
                        marginBottom: '1px'
                      }}>
                        Cupom de
                      </div>
                      <div style={{
                        fontSize: '12px',
                        fontWeight: '600',
                        color: 'var(--pedido-text-primary)',
                        marginBottom: '0px'
                      }}>
                        R$ {valorNum.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </div>
                      <div style={{
                        fontSize: '9px',
                        color: 'var(--pedido-text-muted)'
                      }}>
                        {valorMinimoNum > 0
                          ? `Mínimo R$ ${valorMinimoNum.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                          : 'Sem mínimo'}
                      </div>
                    </div>
                  </div>
                );
              })}


            </div>
          </div>
       )} */}
      </>
    );
  };

  if (!dadosEmpresa) {
    if (checkingSavedStore) {
      return (
        <IonPage id="main-content-inicio" className="Inicio inicio-page">
          <IonContent>
            <div className="inicio-loading-store">
              <IonLoading isOpen spinner="circles" message="Carregando loja..." />
            </div>
          </IonContent>
        </IonPage>
      );
    }

    return <LojaDiscovery onSelectStore={(storeId) => carregarEmpresa(storeId, true)} />;
  }

  return (
    <IonPage id="main-content-inicio" className="Inicio inicio-page">
      <IonHeader className="ion-no-border">
        <div id="div-header-content" ref={headerRef}>









          <IonToolbar>
            {/* Informações da empresa no header */}
            {dadosEmpresa && (
              <div className={`pedido-header-content pedido-header-resumo horario-container ${showHorarioInfo ? 'visible' : 'hidden'}`}>
                {renderEmpresaInfo()}
                {renderBottomInfo()}
              </div>
            )}

            {dadosEmpresa && !dadosEmpresa?.bloquearAcesso && (
              <div className={`pedido-header-content pedido-header-categorias horario-container ${showHorarioInfo ? 'hidden' : 'visible'}`}>
                {renderCategoriaButtons()}
              </div>
            )}

          </IonToolbar>
        </div>
      </IonHeader>

      <IonContent
        ref={contentRef}
        fullscreen={true}          // opcional, ajuda o IonContent ocupar a área
        scrollEvents={true}       // muito importante
        onIonScroll={(e) => handleContentScroll(e)}
      >

        <IonGrid style={{ height: '100%', padding: "0px", margin: "0px" }} ref={contentCatalogoRef}>
          <IonRow style={{ height: '100%' }}>
            <IonCol style={{ height: '100%', padding: "0px", margin: "0px" }} size="12">
              {dadosEmpresa?.bloquearAcesso ? (
                <div style={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'center',
                  padding: '40px 20px',
                  backgroundColor: '#fff'
                }}>
                  <div style={{
                    maxWidth: '400px',
                    width: '100%',
                    textAlign: 'center'
                  }}>
                    {/* Ícone de alerta */}
                    <div style={{
                      width: '64px',
                      height: '64px',
                      margin: '0 auto 20px',
                      backgroundColor: '#ffe5e5',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <IonIcon
                        icon={alertCircleOutline}
                        color="danger"
                        style={{
                          fontSize: '40px',
                        }}
                      />
                    </div>

                    {/* Título */}
                    <h2 style={{
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color: 'var(--pedido-text-primary)',
                      marginBottom: '12px',
                      lineHeight: '1.3'
                    }}>
                      Pedidos temporariamente indisponíveis
                    </h2>

                    {/* Mensagem */}
                    <p style={{
                      fontSize: '15px',
                      color: 'var(--pedido-text-secondary)',
                      lineHeight: '1.6',
                      marginBottom: '24px'
                    }}>
                      No momento, os pedidos online estão pausados para este estabelecimento.
                      Para continuar seu atendimento, fale diretamente com a loja pelo WhatsApp.
                    </p>

                    {/* Botão de WhatsApp */}
                    {dadosEmpresa?.empresaTelefone && (
                      <IonButton
                        expand="block"
                        color="success"
                        style={{
                          '--border-radius': '8px',
                          height: '48px',
                          fontWeight: '600',
                          fontSize: '15px'
                        }}
                        onClick={() => {
                          const numero = dadosEmpresa.empresaTelefone.replace(/\D/g, '');
                          try { analytics.trackLead('whatsapp', { origem: 'inicio' }); } catch (e) { /* noop */ }
                          window.open(`https://wa.me/${numero}`, '_blank');
                        }}
                      >
                        <IonIcon icon={logoWhatsapp} slot="start" />
                        Pedir no WhatsApp
                      </IonButton>
                    )}
                  </div>
                </div>
              ) : (
                <div className="pedido-catalogo-content" style={{ height: '100%' /* REMOVIDO overflow: 'auto' */ }}>
                  <OrdensProdutosCompor
                    empresa={dadosEmpresa}
                    disabled={false}
                    adicionarItem={adicionarItem}
                    productRequest={productRequest}
                    {...({ selectedCategoria, onCategoriaChange: setSelectedCategoria } as any)}
                  />
                </div>
              )}
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonModal isOpen={showModalInformacoes} onDidDismiss={() => { setShowModalInformacoes(false); }}>
          <InformacoesEmpresa closeAction={closeModalInformacoes}></InformacoesEmpresa>
        </IonModal>

        <IonModal className="fullscreen-modal" isOpen={showModalCarrinho} onDidDismiss={() => { setShowModalCarrinho(false); }}>
          <Carrinho adicionarItem={adicionarItem} onChooseProduct={chooseProduct} logado={true} closeAction={closeModalCarrinho} closeActionVoltar={closeModalCarrinhoVoltar}></Carrinho>
        </IonModal>

        <IonModal
          isOpen={welcomeModal !== null}
          backdropDismiss={true}
          className="modal-promocional"
          onDidDismiss={dismissWelcomeModal}
        >
          {dadosEmpresa?.deliveryFechado === true ? (
            <DeliveryClosedNotice reason={getDeliveryClosedReason(dadosEmpresa)} onDismiss={dismissWelcomeModal} />
          ) : (
            <div className="modal-promocional-container">


              <div className="modal-image-section">
                <header className="modal-impact-header">
                  <IonIcon icon={giftOutline} style={{ fontSize: '44px', marginBottom: '10px' }} />
                  <h2 className="modal-impact-title">
                    VOCÊ GANHOU!
                  </h2>
                  <p className="modal-impact-subtitle">Economize agora no seu pedido</p>
                </header>

                <div className="modal-promo-content">
                  {dadosEmpresa?.cashbackAtivado && (
                    <div className="promo-item-impact">
                      <div className="promo-item-icon-box">
                        <IonIcon icon={syncOutline} style={{ fontSize: '24px', color: 'var(--ion-color-primary)' }} />
                      </div>
                      <div className="promo-item-info">
                        <h4>CASHBACK</h4>
                        <p>{dadosEmpresa.percentualCashback || 0}% de volta</p>
                      </div>
                    </div>
                  )}

                  {(() => {
                    // Promo modal: ignora cupons invisíveis.
                    const cuponsVisiveis = Array.isArray(dadosEmpresa?.configuracoesCupom)
                      ? dadosEmpresa.configuracoesCupom.filter((c: any) => c?.visivel !== false)
                      : [];
                    if (cuponsVisiveis.length === 0) return null;
                    return cuponsVisiveis.length > 1 ? (
                      <div className="promo-item-impact">
                        <div className="promo-item-icon-box">
                          <IonIcon icon={ticketOutline} style={{ fontSize: '24px', color: 'var(--ion-color-primary)' }} />
                        </div>
                        <div className="promo-item-info">
                          <h4>CUPONS DISPONÍVEIS</h4>
                          <p>Selecione no carrinho</p>
                        </div>
                      </div>
                    ) : (
                      <div className="promo-item-impact">
                        <div className="promo-item-icon-box">
                          <IonIcon icon={ticketOutline} style={{ fontSize: '24px', color: 'var(--ion-color-primary)' }} />
                        </div>
                        <div className="promo-item-info">
                          <h4>Cupom Disponível</h4>
                          <p>
                            R$ {(() => {
                              try {
                                const cupom = cuponsVisiveis[0];
                                const vStr = (cupom.valor ?? '0').toString();
                                const vNum = parseFloat(vStr.replace(/\./g, '').replace(/\,/g, '.')) || 0;
                                return vNum.toLocaleString('pt-br', { minimumFractionDigits: 2 });
                              } catch (e) { return '0,00'; }
                            })()} OFF no pedido
                          </p>
                        </div>
                      </div>
                    );
                  })()}
                </div>

                <footer className="modal-footer-impact">
                  <button
                    className="modal-impact-cta"
                    onClick={() => {
                      dismissWelcomeModal();
                    }}
                  >
                    Continuar
                  </button>
                </footer>
              </div>
            </div>
          )}
        </IonModal>

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

        <IonAlert
          isOpen={showConfirmStoreSwitch}
          onDidDismiss={() => setShowConfirmStoreSwitch(false)}
          header="Trocar de loja?"
          message="Os itens do carrinho e os dados de entrega serão removidos para você escolher outra loja."
          buttons={[
            { text: 'Cancelar', role: 'cancel' },
            { text: 'Trocar loja', role: 'confirm', handler: clearActiveStore }
          ]}
        />

      </IonContent>

      {!(listaItemProdutos?.length === 0 || dadosEmpresa?.bloquearAcesso) && (
        <div className="pedido-sacola-float">
          <IonButton
            className="pedido-sacola-button"
            expand="block"
            color="primary"
            onClick={async () => {
              const agora = new Date();
              const diaAtual = agora.getDay(); // 0 a 6
              const horarioAtual = agora.getHours() * 60 + agora.getMinutes(); // em minutos

              const diasSemanaNumber: any = {
                SUNDAY: 0,
                MONDAY: 1,
                TUESDAY: 2,
                WEDNESDAY: 3,
                THURSDAY: 4,
                FRIDAY: 5,
                SATURDAY: 6,
              };

              const diaAtualTexto = Object.keys(diasSemanaNumber).find(
                (key) => diasSemanaNumber[key] === diaAtual
              );
              const diaAmanha = (diaAtual + 1) % 7;
              const amanhaTexto = Object.keys(diasSemanaNumber).find(
                (key) => diasSemanaNumber[key] === diaAmanha
              );

              if (dadosEmpresa.horarios) {
                const horariosHoje = dadosEmpresa.horarios.filter(
                  (horario: any) => horario.dayOfWeek === diaAtualTexto
                ) || [];

                const horariosAmanha = dadosEmpresa.horarios.filter(
                  (horario: any) => horario.dayOfWeek === amanhaTexto
                ) || [];

                let estaDentroDoHorario = false;
                let proximoHorarioHoje: any = null;

                for (const horario of horariosHoje.sort((a: any, b: any) => a.start.localeCompare(b.start))) {
                  const [horaInicio, minutoInicio] = horario.start.split(":").map(Number);
                  const inicio = horaInicio * 60 + minutoInicio;
                  const fim = inicio + horario.duration;

                  if (horarioAtual >= inicio && horarioAtual <= fim) {
                    estaDentroDoHorario = true;
                    break;
                  }

                  if (horarioAtual < inicio && !proximoHorarioHoje) {
                    proximoHorarioHoje = horario;
                  }
                }

                const valorTotalProdutosNumerico = parseFloat(
                  valorTotalProdutos?.replace(/\./g, "").replace(/\,/g, ".")
                );
                const pedidoMinimoNumerico = parseFloat(
                  dadosEmpresa.pedidoMinimo?.replace(/\./g, "").replace(/\,/g, ".")
                );

                if (listaItemProdutos?.length === 0) {
                  setTextToast("Selecione pelo menos um produto.");
                  setShowToast(true);
                  // } else if (valorTotalProdutosNumerico < pedidoMinimoNumerico) {
                  //   setTextToast(
                  //     "Pedido mínimo de R$ " + (dadosEmpresa.pedidoMinimo || "0,00") + " em produtos."
                  //   );
                  //   setShowToast(true);
                } else if (dadosEmpresa.agendamento) {
                  setShowModalCarrinho(true);
                } else if (!estaDentroDoHorario) {
                  if (proximoHorarioHoje) {
                    setTextToast(
                      `Não é possível realizar o pedido agora. Abrimos hoje às ${formatarHorario(
                        proximoHorarioHoje.start
                      )}.`
                    );
                  } else if (horariosAmanha.length > 0) {
                    const proximoHorarioAmanha = horariosAmanha.sort((a: any, b: any) =>
                      a.start.localeCompare(b.start)
                    )[0];
                    setTextToast(
                      `Estamos fechados. Abrimos amanhã às ${formatarHorario(
                        proximoHorarioAmanha.start
                      )}.`
                    );
                  } else {
                    setTextToast("Não é possível realizar o pedido, está fora do horário de funcionamento.");
                  }
                  setShowToast(true);
                } else {
                  setShowModalCarrinho(true);
                }
              } else {
                setTextToast("Não é possível realizar o pedido, está fora do horário de funcionamento.");
                setShowToast(true);
              }
            }}
            type="submit"
          >
            <span className="pedido-sacola-left">
              <IonIcon icon={cartOutline} />
              <span>Ver Carrinho</span>
            </span>
            <span className="pedido-sacola-total">
              {valorTotalProdutos ? `R$ ${valorTotalProdutos}` : "R$ 0,00"}
            </span>
          </IonButton>
        </div>
      )}
    </IonPage>
  );
};

export default Inicio;
